import {
  useEmbedConfigureStore,
  type IComponentSettings
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.EXEMATRIX
  )?.configStyle
  const hideTitle = settongs?.find((setting) => setting.id === 'hideTitle')?.value || 'true'
  useIdeStore().setExeMatrixHideTitle(hideTitle === 'true' || false)
  const titleName =
    settongs?.find((setting) => setting.id === 'titleName')?.value || 'Input Arguments:'
  useIdeStore().setExeMatrixTitleName(titleName)
  const display = settongs?.find((setting) => setting.id === 'display')?.value || 'true'
  useIdeStore().setExeMatrixDisplay(display === 'true' || false)
}
/**
 * Get default libs
 */
const resetExeMatrix = () => {
  useIdeStore().resetExecutionMatrix()
}
/**
 * Init exe matrix
 */
const initExeMatrix = () => {
  resetExeMatrix()
}
/**
 * Eject exe matrix
 */
const destroyExeMatrix = () => {
  resetExeMatrix()
}
export default {
  resetExeMatrix,
  onSettingChange,
  initExeMatrix,
  destroyExeMatrix
}
